import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main'
import cases from '@/components/cases'
import article from '@/components/article'
import articleDetail from '@/components/article-detail'
import team from '@/components/team'

Vue.use(Router)

//push 
const VueRouterPush = Router.prototype.push 
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      component: main
    },
    {
      path: '/cases',
      name: 'cases',
      component: cases
    },
    {
      path: '/article',
      name: 'article',
      component: article
    },
    {
      path: '/articleDetail',
      name: 'articleDetail',
      component: articleDetail
    },
    {
      path: '/team',
      name: 'team',
      component: team
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js